import { useTranslation } from 'react-i18next'

import { Checkbox, ChipInput, ComboBox } from '@reveni-io/reveni-ui'

import { missingValueMessages } from '@/common/components/MatchTypeEditor/constants'
import { hasBlankValues } from '@/common/components/MatchTypeEditor/helpers'

import HierarchicalInput from './HierarchicalInput/HierarchicalInput'
import * as Styles from './styles'

const MultiValueInput = ({
  value = [],
  onChange,
  matchCase,
  onChangeMatchCase,
  disabled,
  showCombo,
  comboItems,
  hierarchical,
  hasError,
  rejectsBlankValues,
  inputBackgroundColor,
}) => {
  const { t } = useTranslation()

  const isEmpty = rejectsBlankValues ? hasBlankValues(value) : !Array.isArray(value) || value.length === 0
  const showError = hasError && isEmpty
  const missingValueMessage = rejectsBlankValues ? missingValueMessages.blank : missingValueMessages.empty

  const handleComboChange = e => {
    onChange(e.target.value)
  }

  const handleChangeMatchCase = e => {
    onChangeMatchCase(e.target.checked)
  }

  if (hierarchical) {
    return (
      <HierarchicalInput
        value={value}
        onChange={onChange}
        comboItems={comboItems}
        disabled={disabled}
        hasError={hasError}
      />
    )
  }

  if (showCombo) {
    return (
      <Styles.Container>
        <ComboBox
          label={t('Valores')}
          menuItems={comboItems}
          handleChange={handleComboChange}
          value={value}
          multiple
          fullWidth
          disabled={disabled}
          backgroundColor={inputBackgroundColor}
          error={showError}
          helperText={showError ? t(missingValueMessage) : ' '}
        />
      </Styles.Container>
    )
  }

  return (
    <Styles.Container>
      <ChipInput
        label={t('Valores')}
        value={value}
        onChange={onChange}
        disabled={disabled}
        backgroundColor={inputBackgroundColor}
        error={showError}
        helperText={
          showError
            ? t(missingValueMessage)
            : t('Pulsa Enter o coma para añadir. Pega una lista separada por comas para añadir varios a la vez')
        }
      />
      <Checkbox
        label={t('Distinguir mayúsculas y minúsculas')}
        checked={!!matchCase}
        onChange={handleChangeMatchCase}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default MultiValueInput
